import { CONFIG } from '../config.js';
import { centerOfMass } from './com.js';

export function createEscapeState() {
  return {
    escapeSince: null,
    offscreenSince: null,
    lastEscapeCheckMs: 0,
  };
}

export function bodyInCameraView(body, camera, config = CONFIG) {
  const p = body.position.clone().project(camera);
  return (
    p.z > -1 &&
    p.z < 1 &&
    Math.abs(p.x) <= config.VIEW_MARGIN &&
    Math.abs(p.y) <= config.VIEW_MARGIN
  );
}

export function allBodiesOffscreen(bodies, camera, config = CONFIG) {
  if (!bodies.length) return false;
  for (let i = 0; i < bodies.length; i++) {
    if (bodyInCameraView(bodies[i], camera, config)) return false;
  }
  return true;
}

/**
 * @param {object} opts
 * @param {Array} opts.bodies
 * @param {import('three').Camera} opts.camera
 * @param {number} opts.nowMs
 * @param {ReturnType<typeof createEscapeState>} opts.state
 * @param {(reason: string) => void} opts.onReseed
 * @param {(msg: string) => void} [opts.onNotice]
 * @param {typeof CONFIG} [opts.config]
 */
export function checkEscape({
  bodies,
  camera,
  nowMs,
  state,
  onReseed,
  onNotice,
  config = CONFIG,
  /** When false, skip frustum offscreen reseed (e.g. surface POV). */
  checkOffscreen = true,
}) {
  if (nowMs - state.lastEscapeCheckMs < 500) return;
  state.lastEscapeCheckMs = nowMs;
  if (!bodies.length) return;

  const R = centerOfMass(bodies);
  let tooFar = false;
  for (let i = 0; i < bodies.length; i++) {
    if (bodies[i].position.distanceTo(R) > config.ESCAPE_RADIUS) {
      tooFar = true;
      break;
    }
  }

  if (tooFar) {
    if (state.escapeSince == null) state.escapeSince = nowMs;
    else if ((nowMs - state.escapeSince) / 1000 >= config.ESCAPE_GRACE_SEC) {
      onReseed('escape beyond ' + config.ESCAPE_RADIUS);
      state.escapeSince = null;
      state.offscreenSince = null;
      return;
    }
  } else {
    state.escapeSince = null;
  }

  // POV / transition: camera is on the planet — frustum check is meaningless and false-triggers reseed
  if (!checkOffscreen) {
    state.offscreenSince = null;
    return;
  }

  if (allBodiesOffscreen(bodies, camera, config)) {
    if (state.offscreenSince == null) {
      state.offscreenSince = nowMs;
    } else if ((nowMs - state.offscreenSince) / 1000 >= config.OFFSCREEN_GRACE_SEC) {
      onReseed('all bodies offscreen');
      state.escapeSince = null;
      state.offscreenSince = null;
    } else if (onNotice) {
      onNotice('系统离开视野 · 正在重构');
    }
  } else {
    state.offscreenSince = null;
  }
}
